// utils/buildPoints.ts
import {PointItem} from '../definitions'

type Warehouse = {
  id: string
  air_port?: string
  city?: string
  state?: string
  country?: string
  total?: number
}

const geocodeAddress = (
  geocoder: google.maps.Geocoder,
  address: string
): Promise<google.maps.GeocoderResult | null> => {
  return new Promise((resolve) => {
    geocoder.geocode({address}, (results, status) => {
      if (status !== 'OK' || !results?.[0]) {
        resolve(null)
        return
      }
      resolve(results[0])
    })
  })
}

export const buildPoints = async (warehouses: Warehouse[]): Promise<PointItem[]> => {
  if (!window.google?.maps) {
    throw new Error('Google Maps SDK not loaded')
  }

  const geocoder = new window.google.maps.Geocoder()

  const points = await Promise.all(
    warehouses.map(async (w) => {
      const address = [w.air_port, w.city, w.state, w.country].filter(Boolean).join(', ')

      if (!address) return null

      const result = await geocodeAddress(geocoder, address)
      if (!result) return null

      const loc = result.geometry.location

      return {
        id: w.id,
        title: w.air_port || 'N/A',
        geometry: {
          type: 'Point',
          coordinates: [loc.lng(), loc.lat()],
        },
      } as PointItem
    })
  )

  return points.filter(Boolean) as PointItem[]
}
